import api from './api';
import {
  Tenant,
  TenantDetail,
  TenantUsage,
  CreateTenantRequest,
  CreateTenantResponse,
  UpdateTenantRequest,
  AssignPackageRequest,
  ApiResponse,
} from '../types/tenant';

export interface PagedResult<T> {
  items: T[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export const tenantService = {
  async getAll(page: number = 1, pageSize: number = 20): Promise<ApiResponse<PagedResult<Tenant>>> {
    const { data } = await api.get<ApiResponse<PagedResult<Tenant>>>(`/api/v1/tenants?page=${page}&pageSize=${pageSize}`);
    return data;
  },

  async getById(id: string): Promise<ApiResponse<TenantDetail>> {
    const { data } = await api.get<ApiResponse<TenantDetail>>(`/api/v1/tenants/${id}`);
    return data;
  },

  async create(request: CreateTenantRequest): Promise<ApiResponse<CreateTenantResponse>> {
    const { data } = await api.post<ApiResponse<CreateTenantResponse>>('/api/v1/tenants', request);
    return data;
  },

  async update(id: string, request: UpdateTenantRequest): Promise<ApiResponse<Tenant>> {
    const { data } = await api.put<ApiResponse<Tenant>>(`/api/v1/tenants/${id}`, request);
    return data;
  },

  async assignPackage(id: string, request: AssignPackageRequest): Promise<ApiResponse<Tenant>> {
    const { data } = await api.patch<ApiResponse<Tenant>>(`/api/v1/tenants/${id}/package`, request);
    return data;
  },

  async activate(id: string): Promise<ApiResponse<boolean>> {
    const { data } = await api.patch<ApiResponse<boolean>>(`/api/v1/tenants/${id}/activate`);
    return data;
  },

  async deactivate(id: string): Promise<ApiResponse<boolean>> {
    const { data } = await api.patch<ApiResponse<boolean>>(`/api/v1/tenants/${id}/deactivate`);
    return data;
  },

  async getUsage(id: string): Promise<ApiResponse<TenantUsage>> {
    const { data } = await api.get<ApiResponse<TenantUsage>>(`/api/v1/tenants/${id}/usage`);
    return data;
  },

  async delete(id: string): Promise<ApiResponse<null>> {
    const { data } = await api.delete<ApiResponse<null>>(`/api/v1/tenants/${id}`);
    return data;
  },

  async getMe(): Promise<ApiResponse<TenantDetail>> {
    const { data } = await api.get<ApiResponse<TenantDetail>>('/api/v1/tenants/me');
    return data;
  },

  async getMyUsage(): Promise<ApiResponse<TenantUsage>> {
    const { data } = await api.get<ApiResponse<TenantUsage>>('/api/v1/tenants/me/usage');
    return data;
  },
};
